/**
 * A cor do site.
 *
 * Era uma cor por mês, derivada de `Book.month` e `Event.referenceMonth`.
 * Deixou de ser: o site usa só o rosa da marca, e as funções abaixo
 * continuam existindo porque os componentes chamam todas elas — elas
 * agora devolvem sempre o mesmo hue.
 *
 * Mantê-las no lugar de apagar as chamadas é proposital: se um dia a
 * variação por mês voltar, volta aqui dentro, e nenhum componente muda.
 */

/** A única cor. O array sobrevive porque `data-hue` espera um nome. */
export const HUES = ['rosa'];

/** Hue de marca. É o mesmo em todo lugar agora. */
export const HUE_MARCA = 'rosa';

export const hueForMonth = () => HUE_MARCA;

export const hueForEvento = () => HUE_MARCA;

export const hueForLivro = () => HUE_MARCA;
